// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"37":"2f0ca923","111":"95193a5c","357":"c2f7879e","610":"951a0f36","701":"d888488b"}[chunkId] + ".css";
};